import * as Yup from 'yup';

const categorySchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  imgUrl: Yup.string().required('Image URL is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
  isPrimary: Yup.boolean(),
  emoji: Yup.string().when('isPrimary', {
    is: true,
    then: Yup.string().required('Emoji is required.'),
    otherwise: Yup.string().notRequired(),
  }),
});

export default categorySchema;